module.exports = __webpack_public_path__ + "img/41400.3b37975b.jpg";